import { Collapse as ACollapse, CardProps } from 'antd';

function Collapse(props: CardProps) {
    const { children, defaultActiveTabKey, title } = props;

    return (
        <ACollapse defaultActiveKey={defaultActiveTabKey}>
            <ACollapse.Panel key={1} header={title}>
                {children}
            </ACollapse.Panel>
        </ACollapse>
    );
}

export default Collapse;
